module.exports = __webpack_public_path__ + "img/box_bottom.87d9f2d0.png";